import { query_product_company_list } from '@/api/mjstock-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '厂家名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写厂家名称',
    },
    {
      type: 'input',
      name: 'phone',
      label: '联系电话',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写联系电话',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    phone: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '厂家名称',
    width: 150,
    dataIndex: 'name',
    fixed: false,
    checked: true,
  },
  {
    title: '联系电话',
    width: 150,
    dataIndex: 'phone',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_product_company_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
